import React, { useState, useEffect } from 'react';
import { Button, Checkbox } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import {
  useDataModel, params, string, shape
} from '@thd-nucleus/data-sources';
import { HOME_DEPOT_QUOTE_CENTER } from '../../constants';
import styles from './product-compare.scss';

const cx = classNames.bind(styles);

export const ProductCompare = ({
  onCompare,
  onSelectedForCompare,
  selectedForCompare,
  itemId
}) => {

  const { additionalData } = useImpression({
    data: {
      id: itemId,
      component: 'ProductCompare',
      name: 'ProductCompare',
      position: 0
    }
  });

  const { parent } = additionalData || {};

  const MAX_COMPARABLE = 4;
  const MIN_COMPARABLE = 2;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(selectedForCompare.includes(itemId));
  }, [selectedForCompare, itemId]);

  const onChange = () => {
    setChecked(!checked);
    onSelectedForCompare(itemId, !checked);
    LIFE_CYCLE_EVENT_BUS.trigger('product-pod-v7.compare',
      { podAction: 'product compare', podAnchorSku: itemId, parent });
  };

  const { data } = useDataModel('product', {
    variables: {
      itemId
    }
  });

  const { productSubType } = data?.product?.info || {};

  const isHDQCSku = productSubType?.name === HOME_DEPOT_QUOTE_CENTER;

  if (isHDQCSku) {
    return null;
  }

  return (
    <div className={cx('product-compare')}>
      <Checkbox
        id={`compare-${itemId}`}
        onChange={onChange}
        checked={checked}
        disabled={!checked && selectedForCompare?.length >= MAX_COMPARABLE}
        value={`compare-${itemId}`}
        className="product-compare"
      >
        {(checked && selectedForCompare?.length >= MIN_COMPARABLE)
          ? (
            <Button className="product-compare-now-bttn" onClick={onCompare} cta>
              Compare Now
            </Button>
          )
          : <span>Compare</span>}
      </Checkbox>
    </div>
  );
};

ProductCompare.displayName = 'ProductCompare';

ProductCompare.dataModel = {
  product: params({
    itemId: string().isRequired()
  }).shape({
    itemId: string(),
    dataSources: string(),
    info: shape({
      productSubType: shape({
        name: string()
      })
    })
  })
};

ProductCompare.propTypes = {
  onCompare: PropTypes.func,
  onSelectedForCompare: PropTypes.func,
  selectedForCompare: PropTypes.arrayOf(PropTypes.string),
  itemId: PropTypes.string.isRequired
};

ProductCompare.defaultProps = {
  onCompare: () => { },
  onSelectedForCompare: () => { },
  selectedForCompare: []
};
